import { Vue, Component, Watch } from 'vue-property-decorator';

@Component({})
export default class PopupMakeAThonComponent extends Vue {
  isShowPopupMakeAThon = false;
  isShowPopupMakeAThonLS = localStorage.getItem('isShowPopupMakeAThon') !== undefined ? localStorage.getItem('isShowPopupMakeAThon') : '1';
  language = localStorage.getItem('currentLanguage') !== undefined ? localStorage.getItem('currentLanguage') : 'en';
  imageSrcListEn = 'content/images/images_v3/event/go-event-241111-makerthon-popup-A-en.jpg';
  imageSrcListKo = 'content/images/images_v3/event/go-event-241111-makerthon-popup-A-kor.jpg';
  imageSrc = this.imageSrcListEn;
  url = `${window.origin}/guide`;

  mounted() {
    this.setData();
  }

  setData() {
    const tempSrcList = this.imageSrcListEn;

    if (this.language === 'en') {
      this.imageSrc = this.imageSrcListEn;
    } else {
      this.imageSrc = this.imageSrcListKo;
    }

    setTimeout(() => {
      this.isShowPopupMakeAThon = true;
    }, 500);
  }

  public get authenticated(): boolean {
    return this.$store.getters.authenticated;
  }

  @Watch('$route.fullPath')
  onRouteChange() {
    this.isShowPopupMakeAThon = false;
  }

  doNotShowAgain() {
    localStorage.setItem('isShowPopupMakeAThon', '0');
    this.handleCloseModal();
  }

  handleCloseModal() {
    this.isShowPopupMakeAThon = false;
  }
}
